import { combineReducers } from "redux";
import * as peticioEnCursReducer from "./peticioEnCurs";
import * as valorsReducer from "./valors";
import * as idEspecieReducer from "./idEspecie";
import * as idFenofaseReducer from "./idFenofase";
import * as observacionsReducer from "./observacions";
import * as visibilitatMenuReducer from "./visibilitatMenu";
import * as dataIniciReducer from "./dataInici";
import * as dataFiReducer from "./dataFi";
import * as dataSeleccionadaReducer from "./dataSeleccionada";
import * as tipusActiuReducer from "./tipusActiu";
import * as especieFenofaseSeleccionadaReducer from "./especieFenofaseSeleccionada";

const rootReducer = combineReducers({
  peticioEnCurs: peticioEnCursReducer.default,
  valors: valorsReducer.default,
  idEspecie: idEspecieReducer.default,
  idFenofase: idFenofaseReducer.default,
  observacions: observacionsReducer.default,
  visibilitatMenu: visibilitatMenuReducer.default,
  dataInici: dataIniciReducer.default,
  dataFi: dataFiReducer.default,
  dataSeleccionada: dataSeleccionadaReducer.default,
  tipusActiu: tipusActiuReducer.default,
  especieFenofaseSeleccionada: especieFenofaseSeleccionadaReducer.default
});

export default rootReducer;
export const getPeticioEnCurs = state =>
  peticioEnCursReducer.getPeticioEnCurs(state.peticioEnCurs);
export const getPeticioError = state => {
  peticioEnCursReducer.getPeticioError(state);
};

export const getFenofases = state => valorsReducer.getFenofases(state.valors);
export const getEspecies = state => valorsReducer.getEspecies(state.valors);
export const getEspeciesAsArray = state =>
  valorsReducer.getEspeciesAsArray(state.valors);

export const getIdEspecie = state => idEspecieReducer.getIdEspecie(state);
export const getIdFenofase = state => idFenofaseReducer.getIdFenofase(state);
export const getDataInici = state => dataIniciReducer.getDataInici(state);
export const getDataFi = state => dataFiReducer.getDataFi(state);
export const getDataSeleccionada = state =>
  dataSeleccionadaReducer.getDataSeleccionada(state);

export const getDataIniciAsMoment = state =>
  dataIniciReducer.getDataIniciAsMoment(state);
export const getDataFiAsMoment = state =>
  dataFiReducer.getDataFiAsMoment(state);
export const getDataSeleccionadaAsMoment = state =>
  dataSeleccionadaReducer.getDataSeleccionadaAsMoment(state);

export const getVisibilitatMenu = state =>
  visibilitatMenuReducer.getvisibilitatMenu(state);
export const getVisibilitatObservacions = state =>
  observacionsReducer.getVisibilitatObservacions(state);
export const getVisibilitatObservacionsByCamp = (state, camp) =>
  observacionsReducer.getVisibilitatObservacionsByCamp(state, camp);

export const getTipusActiu = state => tipusActiuReducer.getTipusActiu(state);

export const getEspecieFenofaseSeleccionada = state =>
  especieFenofaseSeleccionadaReducer.getEspecieFenofaseSeleccionada(state);
